export default function ($el) {
	const _self       = this,
		  _$el        = $el,
		  _components = {
			  $form: _$el.find('.__js-sb-form'),
			  $submitBtn: _$el.find('.__js-sb-submit'),
			  $searchField: _$el.find('.__js-sb-autocomplete'),
			  $latField: _$el.find('.__js-sb-lat'),
			  $lngField: _$el.find('.__js-sb-lng'),
			  $momentBtn: _$el.find('.__js-sb-moment-btn'),
			  $momentRadio: _$el.find('.__js-sb-moment-radio'),
			  $momentDatepicker: _$el.find('.__js-sb-moment-datepicker'),
			  $momentDate: _$el.find('.__js-sb-moment-date'),
			  $momentTimeSlot: _$el.find('.__js-sb-moment-time-slot'),
			  $momentTime: _$el.find('.__js-sb-moment-time'),
			  $listenedInput: _$el.find('.js-listen-value'),
			  $hoCustomSelect: _$el.find('.ho-custom-select .selected-item'),
			  $hoCustomSelectPlaceHolder: _$el.find('.ho-custom-select .selected-item').text(),
		  };
	let _autocomplete, _geocoder;

	/**
	 * init function
	 *
	 * @private
	 */
	function _init () {
		window.initSearchBoxServices = _initGoogleServices;

		_initDatepicker();
		_displayDatepicker();
		//_removeTimeValues();
		_displayTimeSlot();
		_updateMomentBtnText();

		_initDynamicFields();

		_onClickCatCollapse();
		_onClickMomentRadio();
		_onChangeMomentTime();
		_onSubmitForm();
		_closeDatepicker();

		_components.$submitBtn.each(function(){
			$(this).click(function(e){
				let valid = true;
				$('select:required,textarea:required,input:required:not(.js-search-entity-input)').each(function(e){
					if (!$(this).val() ){
						valid = false;
						if($(this).parents('.ho-custom-select').length > 0 ){
							$(this).parents('.ho-custom-select').addClass('is-invalid');
						}else{
							$(this).addClass('is-invalid');
						}
						$(this).parents('.input-group').addClass('is-invalid');
					}
				})
				if (valid) {
					_components.$form.submit()
				}
			})
		})

		if ($('.js-optional-display-container').hasClass('preselected')){
			$('.js-optional-display-container').slideDown();
			_$el.find('.js-optional-display').data('dataIsValue', $('#input_constat_type > option:selected').val()).each(function () {
				$(this).show()
			})
		}

	}

	/**
	 * Empêcher la fermeture du collapse Bootstrap en re-cliquant dessus
	 *
	 * @private
	 */
	function _onClickCatCollapse () {
		_$el.find('[data-toggle="collapse"]').on('click', function (e) {
			if ($(this.getAttribute('href')).hasClass('show')) {
				e.stopPropagation();
				e.preventDefault();
			}
		});
	}

	/**
	 * Passer un bouton contenant un input radio en ".active" et "décocher" les autre boutons
	 *
	 * @private
	 */
	function _onClickMomentRadio () {
		_components.$momentRadio.on('change', function () {
			const $radio = $(this);

			// Décocher tous les bouton-radio du même attr HTML "name"
			_components.$momentRadio.filter((i, el) => $(el).attr('name') === $radio.attr('name'))
				.parent('.btn').removeClass('active');
			// Cocher ce bouton-radio
			$radio.parent('.btn').addClass('active');
			// Afficher le datepicker au besoin
			_displayDatepicker();
			// Afficher la sélection d'horaire au besoin
			_displayTimeSlot();
			// Mettre à jour le texte du bouton
			_updateMomentBtnText();
			const $dateRadio = _components.$momentRadio.filter((i, el) => $(el).attr('name') === 'moment_radio_date' && $(el).is(':checked'));
			if ($dateRadio.val() !== 'custom') {
				const $popover = $(this).parents('.sub-input').find('.sub-input__popover');

			}
		});

		$('.custom-date').on('click', function(){
			_displayDatepicker(true);
		})
	}

	/**
	 * Au changement d'heure
	 *
	 * @private
	 */
	function _onChangeMomentTime () {
		_components.$momentTime.on('change', function () {
			_updateMomentBtnText();
		});
	}

	/**
	 * Au submit du form
	 * @private
	 */
	function _onSubmitForm () {

		_components.$form.on('submit', function (e) {
			if (_components.$latField.val() === '' || _components.$lngField.val() === '') {
				e.preventDefault();
				_components.$searchField.addClass('is-invalid');
				_components.$searchField.parents('.input-group').addClass('is-invalid');
			}

		});
	}

	/**
	 * Initialiser le datepicker
	 *
	 * @private
	 */
	function _initDatepicker () {
		_components.$momentDatepicker.datepicker({
			language: 'fr',
			todayHighlight: true,
			maxViewMode: 0,
			format: "MMMM",
		}).on('changeDate', function (e) {
			const date = new Date(e.date);
			// Mettre à jour l'input contenant visuellement la date
			_components.$momentDate.val(_formatDateToIso(date));
			// Mettre à jour le texte du bouton
			_updateMomentBtnText();
			$('.sub-input__form-control').parents('.sub-input').find('.sub-input__popover').removeClass('show');
			$('body').removeClass('sub-input-popover-show');
			$('.js-trigger-backdrop').removeClass('before-backdrop');
		});
	}

	/**
	 * Afficher ou non le datepicker
	 *
	 * @param boolean Forcer l'affichage
	 *
	 * @private
	 */
	function _displayDatepicker (boolean) {
		const $radio = _components.$momentRadio.filter((i, el) => $(el).attr('name') === 'moment_radio_date' && $(el).attr('value') === 'custom');

		if ($radio.is(':checked') || boolean === true) {
			_components.$momentDatepicker.addClass('show');
			_components.$momentDatepicker.parents('.dropdown').addClass('calendar-displayed')
		} else {
			_components.$momentDatepicker.removeClass('show');
			_components.$momentDatepicker.parents('.dropdown').removeClass('calendar-displayed')
		}
		if (boolean === false) {
			_components.$momentDatepicker.removeClass('show');
			_components.$momentDatepicker.parents('.dropdown').removeClass('calendar-displayed')
		}
	}

	function _closeDatepicker () {
		_components.$momentDatepicker.find(' .back').click(function(){
				_components.$momentDatepicker.removeClass('show')
		}
		)
	}

	/**
	 * Afficher ou non les inputs pour sélectionner une plage horaire
	 *
	 * @param boolean Forcer l'affichage
	 *
	 * @private
	 */
	function _displayTimeSlot (boolean) {
		const $radio    = _components.$momentRadio.filter((i, el) => $(el).attr('name') === 'moment_radio_time' && $(el).attr('value') === 'custom'),
			  $fromTime = _components.$momentTime.filter('.from-input'),
			  $toTime   = _components.$momentTime.filter('.to-input');

		if ($radio.is(':checked') || boolean === true) {
			if ($fromTime.val() === null || $toTime.val() === null) {
				_applyDefaultTimeValues();
			}
			_components.$momentTimeSlot.addClass('show');
		} else {
			_components.$momentTimeSlot.removeClass('show');
			_removeTimeValues();
		}
	}

	/**
	 * Appliquer une valeur par défaut aux inputs de temps
	 *
	 * @private
	 */
	function _applyDefaultTimeValues () {
		_components.$momentTime.each(function (i, input) {
			if ($(input).hasClass('from-input')) {
				$(input).val('08:00').change();
			} else if ($(input).hasClass('to-input')) {
				$(input).val('20:00').change();
			}
		});
	}

	/**
	 *  Retirer la valeur des inputs de temps
	 *
	 * @private
	 */
	function _removeTimeValues () {
		_components.$momentTime.each(function (i, input) {
			if ($(input).hasClass('from-input')) {
				$(input).val('').change();
			} else if ($(input).hasClass('to-input')) {
				$(input).val('').change();
			}
		});
	}

	/**
	 * Mettre à jour le texte du bouton affichant le choix de date
	 */
	function _updateMomentBtnText () {
		const $dateRadio = _components.$momentRadio.filter((i, el) => $(el).attr('name') === 'moment_radio_date' && $(el).is(':checked')),
			  $timeRadio = _components.$momentRadio.filter((i, el) => $(el).attr('name') === 'moment_radio_time' && $(el).is(':checked'));
		let txt          = '';

		if ($dateRadio.val() === 'anyway') {
			_components.$momentDate.val('');
		} else if ($dateRadio.val() === 'today') {

			const t = new Date();
			txt     = _formatDateForHuman(t);
			_components.$momentDate.val(_formatDateToIso(t));
		} else if ($dateRadio.val() === 'tomorrow') {
			const t = new Date();
			txt     = _formatDateForHuman(t.addDays(1));
			_components.$momentDate.val(_formatDateToIso(t.addDays(1)));
		} else if ($dateRadio.val() === 'custom') {
			let t = _components.$momentDatepicker.datepicker('getDate') || new Date();
			if (getUrlParameter('moment_date') && _components.$momentDatepicker.datepicker('getDate') == null) {
				t = new Date(getUrlParameter('moment_date'))
			}

			_components.$momentDate.val();
			txt = _formatDateForHuman(t);
		}

		if ($timeRadio.val() === 'custom') {
			let time = '';

			_components.$momentTime.each(function (i, input) {
				if ($(input).hasClass('from-input')) {
					time = $(input).val() + time;
				} else if ($(input).hasClass('to-input')) {
					time = time + ' - ' + $(input).val();
				}
			});

			txt = txt + ' ' + time;

		}
		_components.$momentBtn.val(txt);
	}

	/**
	 * Init Google Maps Autocomplete
	 *
	 * @private
	 */
	function _initGoogleServices () {

		// === Autocomplete ===

		_autocomplete = new google.maps.places.Autocomplete(_components.$searchField[0], {
			types: ['address'],
			componentRestrictions: { country: ["fr", "gp", "mq", "gf", "re", "pm", "yt", "nc", "pf", "mf", "tf"] },
		});
		_autocomplete.setFields(['address_component']);
		_autocomplete.addListener('place_changed', _geocodeAddress);

		// === Geocoder ===
		_geocoder = new google.maps.Geocoder();

		let displayedInput = $(_components.$form.find('#input_location--displayed'));
		displayedInput.keyup(_.debounce(function (){
			$(_components.$searchField[0]).val(displayedInput.val())
			$(_components.$searchField[0]).trigger('focus',function () {
				displayedInput.trigger('focus')
			})
		} , 500));

		$(_components.$searchField[0]).change(function () {
			displayedInput.val($(_components.$searchField[0]).val())
		})
	}

	/**
	 * Geocoder une adresse depuis Google Maps Geocoder
	 *
	 * @private
	 */
	function _geocodeAddress () {
		const place    = _autocomplete.getPlace(),
			  location = place.address_components.map(a => a.long_name).join(' ');

		_lockSubmitBtn();

		_geocoder.geocode({ 'address': location }, function (results, status) {
			if (status === 'OK') {
				const result = results[0],
					  lat    = result.geometry.location.lat(),
					  lng    = result.geometry.location.lng();

				_components.$latField.attr('value', lat);
				_components.$lngField.attr('value', lng);

				_components.$searchField.trigger('change');
			} else {
				toastr.error("Nous n'avons pas pu récupérer l'adresse de la ville saisie. Si l'erreur persiste, contactez-nous.");
				console.error('Geocode was not successful for the following reason: ' + status);
			}


			_unlockSubmitBtn();
		});
	}

	/**
	 * Disable le bouton de submit avec un petit loading
	 *
	 * @private
	 */
	function _lockSubmitBtn () {
		_components.$submitBtn
			.prepend('<i class="fad fa-spinner-third fa-spin fa-fw __sb-loading-icon"></i>')
			.attr('disabled', 'disabled');
	}

	/**
	 * Enable le bouton de submit
	 *
	 * @private
	 */
	function _unlockSubmitBtn () {
		_components.$submitBtn
			.removeAttr('disabled')
			.find('.__sb-loading-icon').remove();
	}

	/**
	 * Écouter certains champs onchange et afficher ou non certains autres champs
	 *
	 * @private
	 */
	function _initDynamicFields () {
		_components.$listenedInput.each(function (i, el) {
			_updateDynamicFields($(el));
		});

		_components.$listenedInput.parent().on('change', function () {
			_updateDynamicFields($(this).find('select'));
		});
	}

	/**
	 * Afficher ou non certains autres champs
	 *
	 * @private
	 */
	function _updateDynamicFields (changedInput) {
		const $input            = $(changedInput),
			  $optionalDisplay  = _$el.find('.js-optional-display'),
			  $optionalRequired = _$el.find('.js-optional-required'),
				$dropdowns = $('.dropdown');
		let active = false;


		// Cacher ou non un champ
		$optionalDisplay.each(function (key, el) {
			const $optionalField = $(el);

			if (_listenedFieldHasRightValues($optionalField, $input)) {
				$dropdowns.each(function () {
					$(this).hide()
				})
				setTimeout(function () {
					$optionalField.show();
					if (!active) {
						setOptionalFielsCookies();
						$('.js-optional-display-container').slideDown();
						active = true;
					}
				},200)
			} else {
				$optionalField.hide();
			}

			if (active === false) {
				$('.js-optional-display-container').slideUp(function(){
					saveOptionalFielsCookies();
				});
			}
		});

		// Require ou non un champ
		$optionalRequired.each(function (key, el) {
			const $optionalInput = $(el);

			if (_listenedFieldHasRightValues($optionalInput, $input)) {
				_toogleOptionalInputsValue($optionalInput, true);
			} else {
				_toogleOptionalInputsValue($optionalInput, false);
			}
		});
	}

	/**
	 * Le champ écouté possède-t-il les bonnes valeurs attendues par le champ optionnel
	 *
	 * @param $optionalEl Le champ optionnel
	 * @param $input Le champ écouté
	 *
	 * @returns {boolean}
	 *
	 * @private
	 */
	function _listenedFieldHasRightValues ($optionalEl, $input) {
		const name = $input.attr('name'),
			  val  = $input.val();
		if (
			($optionalEl.data('if-name') !== undefined && $optionalEl.data('if-name') === name)
			|| ($optionalEl.data('if-class') !== undefined && $input.hasClass($optionalEl.data('if-class')))
		) {
			return val !== null && $optionalEl.data('is-value').toString() === val.toString();
		}
	}

	/**
	 * Split l'année, le mois et le jour d'une date dans un objet {y: year, m: month, d: day}
	 *
	 * @param d
	 * @returns {string}
	 *
	 * @private
	 */
	function _splitDate (d) {
		function pad (s) {
			return (s < 10) ? '0' + s : s;
		}

		return { y: d.getFullYear(), m: pad(d.getMonth() + 1), d: pad(d.getDate()) };
	}

	/**
	 * Convertir une date au format YYYY-MM-DD
	 *
	 * @param d
	 * @returns {string}
	 *
	 * @private
	 */
	function _formatDateToIso (d) {
		const date = _splitDate(d);
		return [date.y, date.m, date.d].join('-');
	}

	/**
	 * Convertir une date au format DD/MM/YYY
	 *
	 * @param d
	 * @returns {string}
	 *
	 * @private
	 */
	function _formatDateForHuman (d) {
		const date = _splitDate(d);
		return [date.d, date.m, date.y].join('/');
	}

	function _toogleOptionalInputsValue($optionalInput,set = false){

		if (set){
			$optionalInput.attr('required', 'required');

			 if (['radio', 'checkbox'].includes($optionalInput.attr('type'))) {
				 if ($optionalInput.attr('checked') ){
					 $optionalInput.prop('checked', true);
				 }else{
					 $optionalInput.prop('checked', false);
				 }
			} else if($optionalInput.is("select")){
				 $optionalInput.val($optionalInput.find(':selected').val())
			 } else {
				 $optionalInput.val($optionalInput.attr('value'));

			 }
		}else{
			$optionalInput.removeAttr('required');

			 if(!['radio', 'checkbox'].includes($optionalInput.attr('type')) && ['select'].includes($optionalInput.attr('type'))){
				$optionalInput.val()
			} else {
				$optionalInput.prop('checked', false);
			}
		}

	}
	/**
	 * Ajoute des jours
	 * @param days
	 * @returns {Date}
	 */
	Date.prototype.addDays = function (days) {
		var date = new Date(this.valueOf());
		date.setDate(date.getDate() + days);
		return date;
	};


	$(_components.$form).on("change",'input[name="convocations"]', function (e) {
		if ($('select[name="group_tag"]').val() === 'habitable_housing') {
			if ($(this).val() === 'no') {
				$('#exampleModalCenter').modal('toggle');
					$('#searchBox').toggleClass('after-modal')

					} else if ($('input[name="convocations"]:checked').val() === 'yes') {

				$('#convoyes').modal('toggle');
					$('#searchBox').toggleClass('after-modal')
			}
		}
		e.stopImmediatePropagation();
	});

	$(_components.$form).on("change",'select[name="group_tag"]', function (e) {

		if ($(this).val() === 'habitable_housing') {
			if ($('input[name="convocations"]:checked').val() === 'no') {

				$('#exampleModalCenter').modal('toggle');
					$('#searchBox').toggleClass('after-modal')

			} else if ($('input[name="convocations"]:checked').val() === 'yes') {

				$('#convoyes').modal('toggle');
					$('#searchBox').toggleClass('after-modal')

			}
		}
		e.stopImmediatePropagation();
	})

	// $('input[name="convocations"]').on("change", function () {
	// 	console.log($('select[name="group_tag"]').val())
	// 	if ($('select[name="group_tag"]').val() === 'habitable_housing') {
	// 		if ($(this).val() === 'no') {
	// 			$('#exampleModalCenter').modal('toggle');
	// 		} else if ($('input[name="convocations"]:checked').val() === 'yes') {
	// 			$('#convoyes').modal('toggle');
	// 		}
	// 	}
	// })

	var getUrlParameter = function getUrlParameter (sParam) {
		var sPageURL      = window.location.search.substring(1),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');

			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
			}
		}
	};

	_init();

	$('[data-toggle="popover"]').popover();

	function setOptionalFielsCookies(){
		let optionalFields = readLocal("options");
		$.each(optionalFields, function(index, value){
			let field = $('[name="'+index+'"]');
			if(field.is("select")){
				field.find('option[value="'+value+'"]').prop('selected', false);
				field.val(value);
			}else if( field.is("input[type='radio']")){
				field.parents('.search-box__input-group').find("input[type='radio'][value='"+value+"']").prop('checked', true);
			}else{
				field.val(value);
			}
		})
	}

	function saveOptionalFielsCookies(){
		let fields = {};
		$('.js-optional-display-container').find('select, input').each(function(){
			fields[$(this).attr('name')] = $(this).val();
			if ($(this).attr('type') === 'radio'){
				fields[$(this).attr('name')] = $(this).val();
			}else{
				$(this).val('');
				$(this).val('');
			}
		})
		if (fields[Object.keys(fields)[0]] !== undefined && fields[Object.keys(fields)[0]] !== null) {
			saveLocal("options", fields);
		}
	}

	function saveLocal(key,data){
		var stored=false;
		if(typeof localStorage!=='undefined') {
			stored = localStorage.getItem(key);
			if(stored!=null)
				stored=true;
			if(typeof(data) === 'object')
				localStorage.setItem(key,JSON.stringify(data));
		}
		return stored;
	}

	function readLocal(key){
		var data=localStorage.getItem(key);
		if(data!=null){
			try{
				data = JSON.parse(data);
			}
			catch(e){}
		}
		return data;
	}
}
